<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ title | globalTranslate }}
    </h1>
  </div>
  <div class="modal-body">
    <p [innerHtml]="body | globalTranslate | sanitize"></p>
  </div>
  <div class="modal-footer justify-content-start">
    <div class="me-2 ml-2">
      @if (showConfirm) {
      <button
        type="button"
        id="dialog"
        class="btn d-grid btn-secondary"
        (click)="onConfirm()"
      >
        {{ confirmButton | globalTranslate }}
      </button>
      }
    </div>
  </div>
</div>